import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	font-family: "Roboto";

	background-color: #f5f5f5;

	width: 100%;
	height: 100%;

	.hidden {
		display: none;
	}

	.show {
		display: flex;
	}
`;

export const Content = styled.div`
	display: flex;

	overflow: hidden;

	height: 100%;

	.menu {
		transition: width 0.3s;
	}

	.hidden {
		width: 0;
	}

	.show {
		position: absolute;

		display: flex;

		width: 35vw;
		height: 100vh;

		overflow: hidden;

		top: 0;
		left: 4px;

		.out-docs {
			display: grid;
			grid-template-columns: 1fr 1fr;
			margin-top: 5rem;
			gap: 10px;

			overflow-y: auto;
			height: 30rem;
		}
	}

	.hidden {
		display: none;
	}

	.form-side {
		display: flex;
		flex-direction: column;

		height: 100vh;

		scroll-behavior: smooth;

		padding: 2rem;

		background-color: #f5f5f5;

		box-shadow: 10px black;

		h2 {
			color: #2d7bbc;

			font-size: 2rem;
			font-weight: 700;
		}

		.form-container,
		form {
			display: grid;
			grid-auto-flow: dense;

			width: 100%;

			grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));

			gap: 1rem;
		}

		.form-container {
			padding: 2rem;

			overflow: auto;
		}

		#instruction {
			color: #c0c4df;

			font-size: 1rem;
		}

		.title {
			color: #2d7bbc;

			font-size: 1.25rem;
			font-weight: 400;

			line-height: 28px;

			margin-bottom: 0.5rem;
		}

		.text-input {
			border: 1px solid #c0c4df;

			height: 2.5rem;
			width: 100%;

			border-radius: 0.25rem;

			transition: border 0.2s;

			padding: 0 0.5rem;

			font-size: 1.2rem;
			font-family: "Mulish";

			::placeholder {
				color: #c0c4df;

				font-size: 1.2rem;
				font-family: "Roboto";
				font-weight: 300;

				line-height: 28px;
			}
		}

		.text-input:focus {
			border: 1px solid #2d7bbc;

			color: #2d7bbc;

			::placeholder {
				color: #2d7bbc;
			}
		}

		.select-input {
			height: 2.5rem;
		}

		.checklist-wrapper {
			display: flex;
			flex-direction: column;

			color: black;

			gap: 0.5rem;

			input {
				margin-right: 1rem;
			}
		}

		.inputs-wrapper {
			text-overflow: ellipsis;
		}

		.dependent-container {
			margin-left: 2rem;
			display: flex;
			align-items: center;
			font-size: 1.08rem;
			gap: 1rem;
			flex-wrap: wrap;

			.dependent-options {
				display: flex;
				gap: 5px;
				label {
					display: flex;
					align-items: center;
					gap: 2px;
				}
				input {
					margin-right: 0;
				}
			}
		}

		.buttons {
			display: flex;

			width: 100%;

			justify-content: space-between;

			margin-top: 3rem;

			button,
			input[type="submit"] {
				border: none;

				cursor: pointer;

				padding: 1rem 3rem;

				border-radius: 0.25rem;

				text-transform: uppercase;

				transition: all 0.3s;

				font-size: 1.25rem;
				font-weight: 700;
			}

			.cancel button {
				background-color: white;

				color: #2d7bbc;

				border: 1px solid #2d7bbc;

				transition: 0.4s;

				:hover {
					border-color: red;

					color: red;
				}
			}

			.next-step button,
			input[type="submit"] {
				background-color: #2d7bbc;
				color: white;
			}
		}
	}

	.docs-side {
		display: block;

		position: relative;

		width: 100%;
		height: 100%;

		background-color: #ececec;

		align-items: center;
		justify-content: center;

		iframe {
			height: 100%;
			width: 100%;
		}

		h1 {
			position: absolute;
			color: #ffffff;
			margin: 2rem;
		}
	}

	form {
		position: relative;

		padding-bottom: 1rem;
	}

	.errors {
		display: flex;
		flex-direction: column;

		margin-top: 0.5rem;

		font-weight: 600;

		color: red;
	}

	.error-form {
		border: 1px solid red !important;
	}

	.select-docs {
		width: 3.5rem;
		height: 3.5rem;

		position: absolute;

		bottom: 0.5rem;
		left: 0;

		padding: 0.25rem;
	}

	.docs-button {
		width: 100%;
		height: 100%;

		border: none;
		border-radius: 50%;

		background-color: white;

		cursor: pointer;

		transition: 0.2s;

		:hover {
			background-color: #3751ff;
		}
	}

	#button-icon {
		width: 70%;
		height: 70%;
	}

	.header {
		display: flex;

		width: 100%;

		justify-content: center;
		align-items: center;

		text-transform: uppercase;

		color: white;

		button {
			border: none;
			background: none;

			cursor: pointer;

			transition: all 0.2s;

			border-radius: 50%;

			padding: 0.5rem 0.6rem;

			svg {
				polyline {
					stroke: #3751ff;
					stroke-width: 3;
				}
			}
		}

		button:hover {
			background-color: rgba(55, 81, 255, 0.2);
		}
	}

	.doc-bg {
		width: 100%;
		height: 100%;

		background-color: white;

		border-radius: 0.3rem;
	}

	.doc-header-wrapper {
		display: flex;

		width: 100%;
		height: 5rem;

		justify-content: space-around;
		align-items: center;

		padding: 0 1rem 0 1rem;
	}

	.doc-button {
		width: 2rem;
		height: 2rem;

		#exit-docs {
			display: flex;

			width: 100%;
			height: 2rem;

			align-items: center;
			justify-content: center;

			border: none;
			border-radius: 50%;

			background: none;

			cursor: pointer;

			transition: 0.2s;

			:hover {
				background-color: red;

				svg {
					color: white;
				}
			}
		}

		svg {
			width: 1.5rem;
			height: 1.5rem;

			color: red;
		}
	}

	.doc-header {
		font-size: 1.5rem;
		font-weight: 700;

		text-align: center;

		color: #3751ff;
	}

	.search-container {
		display: flex;
		flex-direction: column;

		justify-content: center;

		margin-left: 2rem;

		height: 3rem;

		#search {
			border: 2px solid #3751ff;

			background-color: white;
		}

		.search-wrapper {
			display: grid;
			grid-template-columns: max-content max-content;

			align-items: center;
		}

		.button-menu {
			position: relative;

			display: flex;

			width: 10rem;
			height: 2rem;
		}

		.button {
			position: absolute;

			display: flex;

			width: 2.5rem;
			height: 2.5rem;

			border: none;
			border-radius: 2.5rem;

			overflow: hidden;

			align-items: center;

			cursor: pointer;

			transition: 0.35s ease-in-out;
		}

		.button.show {
			height: 2.5rem;

			width: 28rem;

			border-radius: 0.5rem;
		}

		.icon-wrapper {
			display: flex;

			width: 2.3rem;
			height: 100%;

			align-items: center;
			justify-content: center;

			svg {
				width: 1.5rem;
				height: 1.5rem;

				color: #3751ff;
			}
		}

		.input-wrapper {
			width: 2rem;
			input {
				width: 30rem;

				background: none;

				font-size: 1.2rem;

				color: #3751ff;

				border: none;

				::placeholder {
					color: #3751ff;
				}
			}
		}
	}

	.docs-list-wrapper {
		display: grid;

		height: 100%;

		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		grid-template-rows: repeat(auto-fill, minmax(140px, 1fr));

		grid-gap: 0.5rem;

		padding: 1rem;

		overflow: auto;
	}

	.doc-item {
		iframe {
			width: 12rem;
			border: 0px none;
		}
	}
`;

export const DocumentContainer = styled.div`
	margin: 5px 8px;
	border-radius: 2px;

	transition: all 0.2s;
	cursor: pointer;
	position: relative;

	max-height: 18rem;

	.overlay {
		display: none;

		align-items: center;
		justify-content: center;

		z-index: 1000;

		height: 100%;
		width: 100%;

		top: 0;
		left: 0;

		position: absolute;

		color: white;

		background-color: rgba(0, 0, 0, 0.5);
	}

	&:hover {
		.overlay {
			display: flex;
		}
	}
`;
